import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {MatDialog} from '@angular/material/dialog';
import {BtcDonationDialogComponent} from './btc/btc.component';
import {addInitialScenario, AddMortgage, addMortgage, addScenario, loadActions} from './state/effects.actions';
import {HelpDialogComponent} from './help/help.component';
import {AppState, ContractType, financeStateId, MortgageContract} from './state/AppState';
import {LocalStorageActionService} from './local-storage-action.service';
import {AnalyticsService} from "./common/analytics.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'finances-view-app';
  scenarioIds$: Observable<string[]>;

  constructor(
    private store: Store<AppState>,
    private storage: LocalStorageActionService,
    public dialog: MatDialog,
    private analytics: AnalyticsService
  ) {
    this.scenarioIds$ = store
      .pipe(
        select((state) => {
          return state[financeStateId].scenarioIds;
        })
      );

    if (storage.actions.length === 0) {
      this.initializeData();
    } else {
      this.store.dispatch(loadActions());
    }
  }

  ngOnInit(): void {
  }

  private initializeData() {
    this.store.dispatch(addInitialScenario())
    this.store.dispatch(addMortgage({
      scenarioId: '1',
      contract: {
        contractType: ContractType.LINEAR,
        mortgagedAmount: 220000,
        interestRate: 2.01,
        durationMonths: 240,
        monthlyPremium: null,
        startDate: new Date().getTime(),  //FIXME: provide from field
      } as MortgageContract
    } as AddMortgage))
  }

  openBtc(): void {
    this.dialog.open(BtcDonationDialogComponent, {
      width: '30em'
    });
  }

  openFeatureRequest(): void {
    // Todo: Temporary disabled feature request modal
    // this.dialog.open(FeatureDialogComponent, {
    //   width: '100em'
    // });

    this.analytics.action('openedFeatureRequest');
    open('mailto://info@davidstibbe.nl');
  }

  openHelp(): void {
    this.dialog.open(HelpDialogComponent, {
      width: '30em'
    });
  }

  addScenario() {
    this.store.dispatch(addScenario())
  }
}
